import styled from "styled-components";
import { Dialog, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { COLORS } from "../../theme";

export const StyledDialog = styled(Dialog)`
  border-radius: 0 !important;
`;

export const ModalHeader = styled.div`
  position: relative;
  width: 100%;
  height: 28px;
  background-color: ${COLORS.white};
`;

export const StyledIconButton = styled(IconButton)`
  position: absolute !important;
  top: -3px;
  right: 0;
`;

export const StyledCloseIcon = styled(Close)`
  color: ${COLORS.black} !important;
`;
